import { Navigate, useLocation, useParams } from "react-router-dom";

import { PATHS } from "@/lib/config/routesConfig";

export const LegacyAgentChatRedirect = (): JSX.Element => {
  const { agentId = "", chatId } = useParams();
  const { search } = useLocation();
  const chatPath = chatId ? `/${chatId}` : "";

  return (
    <Navigate
      to={`${PATHS.ASSISTANTS}/${agentId}/chat${chatPath}${search}`}
      replace
    />
  );
};
